<template>

    <section
        class="teaser"
        v-bind:class="{ 'isScrolledIntoView' : isLoaded && isReflowed && isScrolledIntoView }"
    >

        <!--
        <div
                class="teaser-inner-loading"
                v-bind:class="{ 'teaser-inner-blank' : !teaserHeading }"
                v-if="isLoading"
        >

            <h2 class="heading" v-if="teaserHeading">
                {{ teaserHeading }}
            </h2>

            <div class="container-fluid">
                <div class="row row-eq-height">

                    <div
                            class="col col-12 col-md-6"
                            v-for="index in teaserMaxItems" :key="index"
                    >
                        <div class="item">
                            <div class="item-inner">
                                <div class="item-image-container">
                                </div>
                                <div class="item-card">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        //-->

        <div
            class="teaser-inner"
            v-bind:class="{ 'teaser-inner-blank' : !teaserHeading }"
            v-if="posts.slice(0, teaserMaxItems).length"
        >

            <h2 class="heading" v-if="teaserHeading">
                {{ teaserHeading }}
            </h2>

            <div class="container-fluid">
                <div class="row row-eq-height">

                    <div
                        class="col col-12 col-md-6"
                        v-for="post in posts.slice(0, teaserMaxItems)"
                    >
                        <router-link :to="wpApi.stripBaseUrl(post['link'])">
                            <div class="item">
                                <div class="item-inner">
                                    <div class="item-image-container">
                                        <div
                                            class="item-image"
                                            v-if="post['acf']['teaser_image_960_720']"
                                            v-bind:style="{ backgroundImage: 'url(' + wpApi.stripHost(post['acf']['teaser_image_960_720']) + ')' }"
                                        >
                                        </div>
                                    </div>
                                    <div class="item-card">
                                        <div class="item-card-inner">
                                            <h4
                                                class="item-heading"
                                                v-html="post['acf']['teaser_title']"
                                            ></h4>
                                            <p
                                                class="item-text"
                                                v-html="post['acf']['teaser_copy']"
                                            ></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="item-action-container">
                                    <div class="item-action">
                                        <div class="item-action-icon"></div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>

                </div>
            </div>

        </div>

    </section>

</template>

<script>

// console.log('Teaser');

import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
import cssUnitHelper from '../services/cssUnitHelper';
import loader from '../services/loader';
import scrollHelper from '../services/scrollHelper';
import wpApi from '../services/wpApi';

export default {
    mixins : [smoothReflow],
    created(){
        this.$root.events.$on('route-transition', ()=>{
            this.scrollHandler();
        });
        window.addEventListener('scroll', this.scrollHandler, { passive : true });
    },
    destroyed(){
        window.removeEventListener('scroll', this.scrollHandler);
        this.$el.removeEventListener('transitionend', this.transitionEndHandler);
    },
    mounted(){
        this.$el.addEventListener('transitionend', this.transitionEndHandler);
        this.$smoothReflow({
            transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
        });
        this.scrollHandler();
        this.load();
    },
    components : {},
    data(){
        return {
            isLoaded : false,
            isLoading : false,
            isReflowed : false,
            isScrolledIntoView : false,
            posts : [],
            scrollViewOffsetTopPx : cssUnitHelper.remToPx(4),
            wpApi,
        };
    },
    props : {
        'teaserExcludePostIds' : {
            default : ()=>{
                return [];
            },
            type : Array,
        },
        'teaserExcludePostPermalinks' : {
            default : ()=>{
                return [];
            },
            type : Array,
        },
        'teaserFilterParams' : {
            default : {},
            type : Object,
        },
        'teaserHeading' : {
            default : '',
            type : String,
        },
        'teaserId' : {
            default : '',
            type : String,
        },
        'teaserMaxItems' : {
            default : 4,
            type : Number,
        },
    },
    methods : {
        load(){
            let url = wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/posts?';
            if (this.teaserFilterParams.posts) {
                url += wpApi.getQueryStringForPostIds(this.teaserFilterParams.posts);
            } else {
                if (this.teaserFilterParams.primaryKeywords.length) {
                    if (typeof this.teaserFilterParams.primaryKeywords[0] === 'number') {
                        url += wpApi.getQueryStringForTaxonomyTagIds(this.teaserFilterParams.primaryKeywords, 'primary_keyword');
                    } else {
                        url += wpApi.getQueryStringForTaxonomyTags(this.teaserFilterParams.primaryKeywords, 'primary_keyword');
                    }
                }
                // if (this.teaserFilterParams.seriesKeywords.length) {
                //     if (typeof this.teaserFilterParams.seriesKeywords[0] === 'number') {
                //         url += wpApi.getQueryStringForTaxonomyTagIds(this.teaserFilterParams.seriesKeywords, 'series_keyword');
                //     } else {
                //         url += wpApi.getQueryStringForTaxonomyTags(this.teaserFilterParams.seriesKeywords, 'series_keyword');
                //     }
                // }
            }
            return wpApi.http.get(url)
                .then((response)=>{
                    console.log('response', response);
                    if (Array.isArray(response.data) === false || response.data.length === 0) {
                        return;
                    }
                    this.posts = response.data;
                    this.isLoaded = true;
                    this.isLoading = false;
                    this.$root.events.$emit('loaded', this.teaserId);
                    if (this.teaserExcludePostPermalinks.length) {
                        this.teaserExcludePostPermalinks.forEach((permalink)=>{
                            this.posts = this.posts.filter((post)=>{
                                if (post.link === wpApi.host + wpApi.baseUrl + '/' + permalink + '/') {
                                    return false;
                                }
                                return true;
                            });
                        });
                    }
                    window.setTimeout(()=>{
                        $('.item-heading').dotdotdot({
                            ellipsis: '\u00A0\u2026',
                        });
                        $('.item-text').dotdotdot({
                            ellipsis: '\u00A0\u2026',
                        });
                    }, 125);
                })
                .catch((error)=>{
                    console.log('error', error);
                });
        },
        scrollHandler(){
            this.isScrolledIntoView = scrollHelper.isScrolledIntoView(
                this.$el, this.scrollViewOffsetTopPx * cssMediaQueryHelper.watch.factor,
            );
            if (this.isScrolledIntoView === false) {
                return;
            }
            // if (loader.isLoading()) {
            //     return;
            // }
            // if (this.isLoaded === false) {
            //     if (this.isLoading === false) {
            //         this.isLoading = true;
            //         loader.queue(this.load());
            //     }
            // }
            window.removeEventListener('scroll', this.scrollHandler);
        },
        transitionEndHandler(event){
            if (this.isLoaded && event.target === this.$el) {
                this.isReflowed = true;
            }
        },
    },
}

</script>

<style lang="scss">

@import '../../css/variables';

.teaser {
    overflow: hidden;
    will-change: height;
    &.isScrolledIntoView {
        .item {
            opacity: 1;
            transform: translateX(0) !important;
            transition: opacity 800ms, transform 800ms;
        }
    }
    &.teaser-black-white {
        background-color: $color-nochvielvor-black;
        .heading {
            color: $color-nochvielvor-white;
        }
    }
    &.teaser-pink-white {
        background-color: $color-nochvielvor-pink;
        .heading {
            color: $color-nochvielvor-white;
        }
    }
    &.teaser-white-pink {
        background-color: $color-nochvielvor-white;
        .heading {
            color: $color-nochvielvor-pink;
        }
        .item {
            .item-card {
                background-color: $color-nochvielvor-pink;
                .item-heading {
                    color: $color-nochvielvor-white;
                }
                .item-text {
                    color: $color-nochvielvor-white;
                }
            }
        }
        .teaser-inner-loading {
            .item {
                background: transparentize($color-nochvielvor-black, .9);
                .item-card {
                    background: transparentize($color-nochvielvor-black, .9);
                }
            }
        }
    }
    &.teaser-transparent-pink {
        background-color: transparent;
        .heading {
            color: $color-nochvielvor-pink;
        }
        .item {
            .item-card {
                background-color: $color-nochvielvor-pink;
                .item-heading {
                    color: $color-nochvielvor-white;
                }
                .item-text {
                    color: $color-nochvielvor-white;
                }
            }
        }
    }
    &.teaser-transparent-white-pink {
        background-color: transparentize($color-nochvielvor-white, 0.1);
        .heading {
            color: $color-nochvielvor-pink;
        }
        .item {
            .item-card {
                background-color: $color-nochvielvor-black;
                .item-heading {
                    color: $color-nochvielvor-white;
                }
                .item-text {
                    color: $color-nochvielvor-white;
                }
            }
            .item-action-container {
                .item-action {
                    background-color: $color-nochvielvor-pink;
                    .item-action-icon {
                        background-image: url(/img/ic_plus_000000.svg);
                    }
                }
            }
        }
        .teaser-inner-loading {
            .item {
                background: transparentize($color-nochvielvor-black, .9);
                .item-card {
                    background: transparentize($color-nochvielvor-black, .9);
                }
            }
        }
    }
    a {
        &,
        &:hover {
            text-decoration: none;
        }
    }
    .teaser-inner {
        padding: 0 1.5rem 0.5rem 1.5rem;
        @media screen and (min-width: 1200px) {
            padding: 0 1.5rem * $factor-1200 0.5rem * $factor-1200 1.5rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            padding: 0 1.5rem * $factor-1440 0.5rem * $factor-1440 1.5rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            padding: 0 1.5rem * $factor-1920 0.5rem * $factor-1920 1.5rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            padding: 0 1.5rem * $factor-2400 0.5rem * $factor-2400 1.5rem * $factor-2400;
        }
        &.teaser-inner-blank {
            /*
            padding-top: 4rem;
            @media screen and (min-width: 1200px) {
                padding-top: 4rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-top: 4rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding-top: 4rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding-top: 4rem * $factor-2400;
            }
            */
        }
    }
    .teaser-inner-loading {
        padding: 2.5rem 1.5rem 4rem 1.5rem;
        @media screen and (min-width: 1200px) {
            padding: 2.5rem * $factor-1200 1.5rem * $factor-1200 4rem * $factor-1200 1.5rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            padding: 2.5rem * $factor-1440 1.5rem * $factor-1440 4rem * $factor-1440 1.5rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            padding: 2.5rem * $factor-1920 1.5rem * $factor-1920 4rem * $factor-1920 1.5rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            padding: 2.5rem * $factor-2400 1.5rem * $factor-2400 4rem * $factor-2400 1.5rem * $factor-2400;
        }
        &.teaser-inner-blank {
            padding-top: 4rem;
            @media screen and (min-width: 1200px) {
                padding-top: 4rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-top: 4rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding-top: 4rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding-top: 4rem * $factor-2400;
            }
        }
        .item {

            // TODO
            display: none;

            min-height: 2rem;
            background: transparentize($color-nochvielvor-white, .9);
            opacity: 1;
            transform: translateX(0) !important;
            transition: opacity 800ms, transform 800ms;
            @media screen and (min-width: 1200px) {
                min-height: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                min-height: 2rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                min-height: 2rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                min-height: 2rem * $factor-2400;
            }
            .item-card {
                background: transparentize($color-nochvielvor-white, .9);
            }
        }
    }
    .container-fluid {
        margin: 0;
        padding: 0;
        .row {
            margin: 0 -0.75rem;
            @media screen and (min-width: 1200px) {
                margin: 0 -0.75rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 -0.75rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 -0.75rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 -0.75rem * $factor-2400;
            }
            .col {
                padding: 1.5rem 0.75rem;
                padding-bottom: 1.125rem * 1.415;
                @media screen and (min-width: 1200px) {
                    padding: 1.5rem * $factor-1200 0.75rem * $factor-1200;
                    padding-bottom: 1.125rem * 1.415 * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding: 1.5rem * $factor-1440 0.75rem * $factor-1440;
                    padding-bottom: 1.125rem * 1.415 * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding: 1.5rem * $factor-1920 0.75rem * $factor-1920;
                    padding-bottom: 1.125rem * 1.415 * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding: 1.5rem * $factor-2400 0.75rem * $factor-2400;
                    padding-bottom: 1.125rem * 1.415 * $factor-2400;
                }
                @for $i from 1 through 20 {
                    &:nth-child(#{$i}) {
                        .item {
                            transition-delay: #{$i * 200}ms;
                        }
                    }
                }
                &:nth-child(even) {
                    .item {
                        transform: translateX(100%);
                    }
                }
                &:nth-child(odd) {
                    .item {
                        transform: translateX(-100%);
                    }
                }
            }
        }
    }
    .heading {
        margin: 0 0 1.5rem 0;
        color: $color-nochvielvor-black;
        font-size: 2.25rem;
        font-weight: bold;
        text-transform: uppercase;
        @media screen and (min-width: 1200px) {
            margin: 0 0 1.5rem * $factor-1200 0;
            font-size: 2.25rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin: 0 0 1.5rem * $factor-1440 0;
            font-size: 2.25rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin: 0 0 1.5rem * $factor-1920 0;
            font-size: 2.25rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin: 0 0 1.5rem * $factor-2400 0;
            font-size: 2.25rem * $factor-2400;
        }
    }
    .item {
        position: relative;
        width: 100%;
        height: 100%;
        opacity: 0;
        overflow: visible;
        transition: none;
        will-change: opacity, transform;
        &:hover {
            .item-image-container {
                /*
                transform: translateX(-4rem);
                @media screen and (max-width: 767px) {
                    transform: translateX(-4rem * $factor-720);
                }
                @media screen and (min-width: 1200px) {
                    transform: translateX(-4rem * $factor-1200);
                }
                @media screen and (min-width: 1440px) {
                    transform: translateX(-4rem * $factor-1440);
                }
                @media screen and (min-width: 1920px) {
                    transform: translateX(-4rem * $factor-1920);
                }
                @media screen and (min-width: 2400px) {
                    transform: translateX(-4rem * $factor-2400);
                }
                */
                .item-image {
                    transform: scale(1.2);
                }
            }
            .item-card {
                /*
                transform: translateX(-4rem);
                @media screen and (max-width: 767px) {
                    transform: translateX(-4rem * $factor-720);
                }
                @media screen and (min-width: 1200px) {
                    transform: translateX(-4rem * $factor-1200);
                }
                @media screen and (min-width: 1440px) {
                    transform: translateX(-4rem * $factor-1440);
                }
                @media screen and (min-width: 1920px) {
                    transform: translateX(-4rem * $factor-1920);
                }
                @media screen and (min-width: 2400px) {
                    transform: translateX(-4rem * $factor-2400);
                }
                .item-card-inner {
                    transform: translateX(2rem);
                    @media screen and (max-width: 767px) {
                        transform: translateX(2rem * $factor-720);
                    }
                    @media screen and (min-width: 1200px) {
                        transform: translateX(2rem * $factor-1200);
                    }
                    @media screen and (min-width: 1440px) {
                        transform: translateX(2rem * $factor-1440);
                    }
                    @media screen and (min-width: 1920px) {
                        transform: translateX(2rem * $factor-1920);
                    }
                    @media screen and (min-width: 2400px) {
                        transform: translateX(2rem * $factor-2400);
                    }
                }
                */
            }
            .item-action-container {
                /*
                transform: translateX(-2rem);
                @media screen and (max-width: 767px) {
                    transform: translateX(-2rem * $factor-720);
                }
                @media screen and (min-width: 1200px) {
                    transform: translateX(-2rem * $factor-1200);
                }
                @media screen and (min-width: 1440px) {
                    transform: translateX(-2rem * $factor-1440);
                }
                @media screen and (min-width: 1920px) {
                    transform: translateX(-2rem * $factor-1920);
                }
                @media screen and (min-width: 2400px) {
                    transform: translateX(-2rem * $factor-2400);
                }
                */
                .item-action {
                    animation-name: item-action-scale-pulse;
                    .item-action-icon {
                    }
                }
            }
        }
        .item-inner {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
        .item-image-container {
            width: 52.5%;
            min-width: 52.5%;
            overflow: hidden;
            transition: transform 400ms;
            will-change: transform;
            @media screen and (max-width: 767px) {
                width: 47.5%;
                min-width: 47.5%;
            }
            .item-image {
                width: 100%;
                height: 100%;
                background-position: 50% 50%;
                background-repeat: no-repeat;
                background-size: cover;
                // transform-origin: 100% 50%;
                transform: scale(1.1);
                transition: transform 1200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                will-change: transform;
            }
        }
        .item-card {
            display: flex;
            flex-direction: column;
            width: calc(47.5% + 4rem);
            min-width: calc(47.5% + 4rem);
            height: 100%;
            padding: 0 4.5rem 0 0.5rem;
            background-color: $color-nochvielvor-white;
            transition: transform 400ms;
            will-change: transform;
            @media screen and (max-width: 767px) {
                width: calc(52.5% + 4rem * #{$factor-720});
                min-width: calc(52.5% + 4rem * #{$factor-720});
                padding: 0 4.5rem * $factor-720 0 0.5rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                width: calc(47.5% + 4rem * #{$factor-1200});
                min-width: calc(47.5% + 4rem * #{$factor-1200});
                padding: 0 4.5rem * $factor-1200 0 0.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                width: calc(47.5% + 4rem * #{$factor-1440});
                min-width: calc(47.5% + 4rem * #{$factor-1440});
                padding: 0 4.5rem * $factor-1440 0 0.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                width: calc(47.5% + 4rem * #{$factor-1920});
                min-width: calc(47.5% + 4rem * #{$factor-1920});
                padding: 0 4.5rem * $factor-1920 0 0.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                width: calc(47.5% + 4rem * #{$factor-2400});
                min-width: calc(47.5% + 4rem * #{$factor-2400});
                padding: 0 4.5rem * $factor-2400 0 0.5rem * $factor-2400;
            }
            .item-card-inner {
                position: relative;
                height: 100%;
                padding: 2rem 0;
                transition: transform 400ms;
                will-change: transform;
                @media screen and (min-width: 1200px) {
                    padding: 2rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    padding: 2rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    padding: 2rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    padding: 2rem * $factor-2400 0;
                }
            }
            .item-heading {
                margin: auto 0 1rem 0;
                max-height: 22px * 2;
                color: $color-nochvielvor-black;
                font-size: 1.125rem;
                font-weight: bold;
                text-align: center;
                text-transform: uppercase;
                @media screen and (min-width: 1200px) {
                    max-height: 22px * 2 * $factor-1200;
                    font-size: 1.125rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    max-height: 22px * 2 * $factor-1440;
                    font-size: 1.125rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    max-height: 22px * 2 * $factor-1920;
                    font-size: 1.125rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    max-height: 22px * 2 * $factor-2400;
                    font-size: 1.125rem * $factor-2400;
                }
            }
            .item-text {
                margin: 0 0 auto 0;
                max-height: 14px * 6;
                color: $color-nochvielvor-black;
                font-size: 0.75rem;
                text-align: center;
                @media screen and (min-width: 1200px) {
                    max-height: 14px * 6 * $factor-1200;
                    font-size: 0.75rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    max-height: 14px * 6 * $factor-1440;
                    font-size: 0.75rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    max-height: 14px * 6 * $factor-1920;
                    font-size: 0.75rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    max-height: 14px * 6 * $factor-2400;
                    font-size: 0.75rem * $factor-2400;
                }
            }
        }
        .item-action-container {
            position: absolute;
            left: 76.25%;
            bottom: 0;
            transition: transform 400ms;
            will-change: transform;
            .item-action {
                width: 2.25rem;
                height: 2.25rem;
                background-color: $color-nochvielvor-black;
                animation-duration: 800ms;
                animation-iteration-count: infinite;
                animation-timing-function: ease-in-out;
                transform: translate3d(-50%, 50%, 0) rotate(-45deg);
                transition: background-color 400ms, transform 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                will-change: background-color, transform;
                @media screen and (min-width: 1200px) {
                    width: 2.25rem * $factor-1200;
                    height: 2.25rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: 2.25rem * $factor-1440;
                    height: 2.25rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: 2.25rem * $factor-1920;
                    height: 2.25rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: 2.25rem * $factor-2400;
                    height: 2.25rem * $factor-2400;
                }
                @keyframes item-action-scale-pulse {
                    0% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1);
                    }
                    50% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1.1);
                    }
                    100% {
                        transform: translate3d(-50%, 50%, 0) rotate(-45deg) scale(1);
                    }
                }
                .item-action-icon {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 1.0625rem;
                    height: 1.0625rem;
                    background-image: url(/img/ic_plus_ffffff.svg);
                    background-position: 50% 50%;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    transform: translate3d(-50%, -50%, 0) rotate(45deg);
                    transition: transform 1200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                    will-change: transform;
                    @media screen and (min-width: 1200px) {
                        width: 1.0625rem * $factor-1200;
                        height: 1.0625rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        width: 1.0625rem * $factor-1440;
                        height: 1.0625rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        width: 1.0625rem * $factor-1920;
                        height: 1.0625rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        width: 1.0625rem * $factor-2400;
                        height: 1.0625rem * $factor-2400;
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// public/js/components/Teaser.vue